export function artworkMediaSticky() {
    const $window = $(window);
    const $media = $(".hero-media");
    const $header = $(".header");
    const artworkHero = $(".artwork-hero");

    $window.on("load scroll resize", function () {
        if (window.innerWidth >= 1200) {
            let top = artworkHero.offset().top;
            let artworkHeroHeight = artworkHero.innerHeight();
            let mediaHeight = $media.innerHeight();
            let headerHeight;
            if ($header.hasClass("sticky")) {
                headerHeight = $header.innerHeight();
            }

            if ($window.scrollTop() > top + artworkHeroHeight - mediaHeight - headerHeight && !$media.hasClass("sticky")) {
                $media.addClass("sticky").css({
                    "position": "fixed",
                    "top": headerHeight,
                    "bottom": "auto"
                });
            }
            if ($window.scrollTop() < top + artworkHeroHeight - mediaHeight - headerHeight && $media.hasClass("sticky")) {
                $media.removeClass("sticky").attr("style", "");
            }
        } else {
            // if ($window.scrollTop() < top + artworkHeroHeight - mediaHeight - headerHeight && $media.hasClass("sticky")) {
            $media.removeClass("sticky").attr("style", "");
            // }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/artworkMediaSticky.js